<mat-icon aria-hidden="false" aria-label="login icon" svgIcon="horse-placeholder"></mat-icon>
<h1>{{ "auth.title.login" | translate }}</h1>